// useLogisticsAlertCount — live count of outstanding logistics work: loads
// (load_date ≤ the next working day) still missing a pre-load requirement, plus transactions
// whose unload notification (awizacja rozładunku) or wjazdówka hasn't been sent.
// Drives the red badge on the "Alerty Logistyki" sider item.
//
// Reuses the SAME count path the queue tab badges use (`useRunListQuery` with a
// 1-row page → `result.total`) against the SAME source + filters as the alert
// page (`logisticsLoadAlertsFilters` over `transactions_with_checks` via
// `transactionDataSchema`). Badge and page therefore never drift. The filter is
// rebuilt each render so the today→next-working-day window stays correct; React Query
// refetches on focus/invalidation so the badge stays fresh without a reload.

import { useMemo } from "react";
import type { Transaction } from "@shared/types/transaction";
import type { Query } from "@ds/config/query";
import { useRunListQuery } from "@ds/config/runQuery";
import { transactionDataSchema } from "@entities/transactions/transactionConfig";
import { logisticsLoadAlertsFilters } from "@entities/transactions/queue/logisticsPresets";

export function useLogisticsAlertCount(enabled: boolean): number {
  const query = useMemo<Query<Transaction>>(
    () => ({
      schema: transactionDataSchema,
      filter: logisticsLoadAlertsFilters(),
      page: { size: 1 },
      enabled,
    }),
    [enabled],
  );
  const { result } = useRunListQuery(query);
  return result?.total ?? 0;
}
